var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-img',{attrs:{"src":require(("@/assets/images/flags/" + (_vm.$i18n.locale) + ".png")),"alt":_vm.$i18n.locale,"height":"14px","width":"22px"},on:{"click":function($event){_vm.isEnglish = !_vm.isEnglish}}})}
var staticRenderFns = []

export { render, staticRenderFns }